<template>
    <form class="col-md-12 mx-auto" @submit.prevent="onSave">
        <div class="card border-primary mb-3">
            <h5 class="card-header text-primary"><i class="fas fa-user-edit mr-2"></i>{{fullName}}</h5>

            <div v-if="model.person">
                <PersonSelectorCard ref="personSelector"
                                    v-model="model.person"
                                    :title="''"
                                    :showId="false"
                                    @searching="personSearching = true"
                                    @stopSearching="personSearching = false">
                </PersonSelectorCard>
            </div>

            <div class="card-body" v-if="!personSearching">
                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.firstName ? 'required' : ''"
                               :for="'firstName' + _uid">
                            {{$t('person.firstName')}}
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.firstName"
                               v-validate="tempRakingCandidateRequiredFields.firstName ? 'required' : ''"
                               :data-vv-as="$t('person.firstName')"
                               :name="'firstName' + _uid"
                               :id="'firstName' + _uid" />
                        <span class="text-danger" v-if="errors.has('firstName' + _uid)">{{ errors.first('firstName' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.middleName ? 'required' : ''"
                               :for="'middleName' + _uid">{{ $t('person.middleName') }}</label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.middleName"
                               v-validate="tempRakingCandidateRequiredFields.middleName ? 'required' : ''"
                               :data-vv-as="$t('person.middleName')"
                               :id="'middleName' + _uid"
                               :name="'middleName' + _uid" />
                        <span class="text-danger" v-if="errors.has('middleName' + _uid)">{{ errors.first('middleName' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.lastName ? 'required' : ''"
                               :for="'lastName' + _uid">
                            {{ $t('person.lastName')}}
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.lastName"
                               v-validate="tempRakingCandidateRequiredFields.lastName ? 'required' : ''"
                               :data-vv-as="$t('person.lastName')"
                               :name="'lastName' + _uid"
                               :id="'lastName' + _uid" />
                        <span class="text-danger" v-if="errors.has('lastName' + _uid)">{{ errors.first('lastName' + _uid) }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-8">
                        <label
                            class="font-weight-bold"
                            :class="tempRakingCandidateRequiredFields.identificationNumber ? 'required' : ''"
                        >{{ $t('person.identification') }}</label>
                        <person-identification :identification="model.person.personIdentification"
                                               :required="tempRakingCandidateRequiredFields.identificationNumber"
                                               :disabled="false"
                                               :validateUniqueIdNumber="validateUniqueIdNumber"
                                               :validateEgn="validateEgn"
                                               @getGenderTypeId="model.person.genderTypeId = $event">
                        </person-identification>
                    </div>

                    <div class="form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold" :class="tempRakingCandidateRequiredFields.gender ? 'required' : ''">{{ $t('person.gender') }}</label>
                        <dropdown :loadByParentSort="true"
                                  :parentSort="genderTypeSort"
                                  :required="tempRakingCandidateRequiredFields.gender"
                                  v-model="model.person.genderTypeId"
                                  :fieldName="$t('person.gender')"
                                  :disabled="false">
                        </dropdown>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.idCardNumber ? 'required' : ''"
                               :for="'idCardNumber' + _uid">{{ $t('person.idCardNumber') }}</label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.idCardNumber"
                               v-validate="tempRakingCandidateRequiredFields.idCardNumber ? 'required' : ''"
                               :data-vv-as="$t('person.idCardNumber')"
                               :name="'idCardNumber' + _uid"
                               :id="'idCardNumber' + _uid" />
                        <span class="text-danger" v-if="errors.has('idCardNumber' + _uid)">{{ errors.first('idCardNumber' + _uid) }}</span>
                    </div>


                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.idCardDateOfIssue ? 'required' : ''"
                               :for="'idCardDateOfIssue' + _uid">{{ $t('person.idCardDateOfIssue') }}</label>
                        <date-only-picker v-model="model.person.idCardDateOfIssue"
                                          :enableTimePicker="false"
                                          :required="tempRakingCandidateRequiredFields.idCardDateOfIssue"
                                          :readonly="false"
                                          :showTime="false"
                                          :id="'idCardDateOfIssue' + _uid"
                                          :name="'idCardDateOfIssue' + _uid">
                        </date-only-picker>
                    </div>

                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.idCardIssuedBy ? 'required' : ''"
                               :for="'idCardIssuedBy' + _uid">{{ $t('person.idCardIssuedBy') }}</label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.idCardIssuedBy"
                               v-validate="tempRakingCandidateRequiredFields.idCardIssuedBy ? 'required' : ''"
                               :data-vv-as="$t('person.idCardIssuedBy')"
                               :name="'idCardIssuedBy' + _uid"
                               :id="'idCardIssuedBy' + _uid" />
                        <span class="text-danger" v-if="errors.has('idCardIssuedBy' + _uid)">{{ errors.first('idCardIssuedBy' + _uid) }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.email ? 'required' : ''"
                               :for="'email' + _uid">{{ $t('email') }}</label>
                        <input type="email"
                               class="form-control"
                               :readonly="false"
                               v-model="model.person.email"
                               v-validate="tempRakingCandidateRequiredFields.email ? 'required|email' : 'email'"
                               :data-vv-as="$t('email')"
                               :name="'email' + _uid"
                               :id="'email' + _uid" />
                        <span class="text-danger" v-if="errors.has('email' + _uid)">{{ errors.first('email' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.phone ? 'required' : ''"
                               :for="'phone' + _uid" :readonly="false">
                            {{ $t('person.phone') }}
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.phone"
                               v-validate="tempRakingCandidateRequiredFields.phone ? 'required' : ''"
                               :data-vv-as="$t('person.phone')"
                               :id="'phone' + _uid"
                               :name="'phone' + _uid"
                               :readonly="false" />
                        <span class="text-danger" v-if="errors.has('phone' + _uid)">{{ errors.first('phone' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.mobilePhone ? 'required' : ''"
                               :for="'mobilePhone' + _uid">
                            {{ $t('person.mobilePhone') }}
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.mobilePhone"
                               v-validate="tempRakingCandidateRequiredFields.mobilePhone ? 'required' : ''"
                               :data-vv-as="$t('person.mobilePhone')"
                               :id="'mobilePhone' + _uid"
                               :name="'mobilePhone' + _uid"
                               :readonly="false" />
                        <span class="text-danger" v-if="errors.has('mobilePhone' + _uid)">{{ errors.first('mobilePhone' + _uid) }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold">{{ $t('person.description') }}</label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.description"
                               :id="'description' + _uid"
                               :readonly="false" />
                    </div>
                </div>

                <InstitutionSelector v-model="model.person" :is-required="tempRakingCandidateRequiredFields.institution"></InstitutionSelector>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :class="tempRakingCandidateRequiredFields.positionStatistic ? 'required' : ''"
                        >{{ $t('person.positionStatistic') }}</label>
                        <dropdown :loadByParentSort="true"
                                  :parentSort="positionStatisticSort"
                                  v-model="model.person.positionStatisticId"
                                  :required="tempRakingCandidateRequiredFields.positionStatistic"
                                  :fieldName="$t('person.positionStatistic')"
                                  :disabled="false">
                        </dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="tempRakingCandidateRequiredFields.positionStatistic ? 'required' : ''">{{ $t('person.position') }}</label>
                        <dropdown :loadByParentSort="true"
                                  :parentSort="positionSort"
                                  :required="tempRakingCandidateRequiredFields.position"
                                  v-model="model.person.position"
                                  :fieldName="$t('person.position')"
                                  :disabled="false">
                        </dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :for="'positionStr' + _uid">{{ $t('person.positionFullName') }}</label>
                        <input type="text"
                               class="form-control"
                               v-model="model.person.positionStr"
                               :id="'positionStr' + _uid" />
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.salutation') }}</label>
                        <dropdown :loadByParentSort="true"
                                  :parentSort="salutationSort"
                                  v-model="model.person.salutationId"
                                  :fieldName="$t('person.salutation')"
                                  :disabled="false">
                        </dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.titleDegree') }}</label>
                        <dropdown :loadByParentSort="true"
                                  :parentSort="titleDegreeSort"
                                  v-model="model.person.titleDegreeId"
                                  :fieldName="$t('person.titleDegree')"
                                  :disabled="false">
                        </dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :class="tempRakingCandidateRequiredFields.education ? 'required' : ''">{{ $t('person.educationDegree') }}</label>
                        <dropdown :loadByParentSort="true"
                                  :parentSort="educationDegreeSort"
                                  :required="tempRakingCandidateRequiredFields.education"
                                  v-model="model.person.educationDegreeId"
                                  :fieldName="$t('person.educationDegree')"
                                  :disabled="false">
                        </dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('reportData.participants.cityOfCurrentAddress') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.cityOfCurrentAddress"
                            :name="'cityOfCurrentAddress' + _uid"
                            :id="'cityOfCurrentAddress' + _uid"
                        />
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">
                            {{ $t('reportData.participants.currentSettlement') }}
                        </label>
                        <city-dropdown-search v-model="model.currentSettlementId"></city-dropdown-search>
                    </div>
                </div>

                <hr />

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'note' + _uid">{{ $t('registers.events.participants.gridHeaders.note') }}</label>
                        <textarea class="form-control" rows="5"
                                  v-model="model.note"
                                  :name="'note' + _uid"
                                  :id="'note' + _uid">
                                </textarea>
                    </div>
                </div>

                <hr />

                <div class="row mt-md-2 mt-sm-1">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isMigrant"
                                     :name="'isMigrant' + _uid"
                                     :id="'isMigrant' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isMigrant') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isForeigner"
                                     :name="'isForeigner' + _uid"
                                     :id="'isForeigner' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isForeigner') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isMemberOfAMinority"
                                     :name="'isMemberOfAMinority' + _uid"
                                     :id="'isMemberOfAMinority' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isMemberOfAMinority') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isOfGypsyOrigin"
                                     :name="'isOfGypsyOrigin' + _uid"
                                     :id="'isOfGypsyOrigin' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isOfGypsyOrigin') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.withDisabilities"
                                     :name="'withDisabilities' + _uid"
                                     :id="'withDisabilities' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.withDisabilities') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isHomeless"
                                     :name="'isHomeless' + _uid"
                                     :id="'isHomeless' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isHomeless') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isDisadvantaged"
                                     :name="'isDisadvantaged' + _uid"
                                     :id="'isDisadvantaged' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isDisadvantaged') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.isFromUnemployedHousehold"
                                     :name="'isFromUnemployedHousehold' + _uid"
                                     :id="'isFromUnemployedHousehold' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.isFromUnemployedHousehold') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.withDependentChildren"
                                     :name="'withDependentChildren' + _uid"
                                     :id="'withDependentChildren' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.withDependentChildren') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox v-model="model.fromOneMemberHousehold"
                                     :name="'fromOneMemberHousehold' + _uid"
                                     :id="'fromOneMemberHousehold' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('reportData.participants.fromOneMemberHousehold') }}
                        </vs-checkbox>
                    </div>
                </div>

                <hr />

                <div class="form-group col-10 row pl-2"
                     v-if="!isNew"
                     aria-describedby="updatePersonFromParticipantHelpBlock">
                    <i class="fas fa-exclamation-triangle fa-2x text-warning ml-2 mr-2"
                       v-if="model.updatePersonFromParticipant"></i>
                    <vs-checkbox v-model="model.updatePersonFromParticipant"
                                 :name="'updatePersonFromParticipant' + _uid"
                                 :id="'updatePersonFromParticipant' + _uid"
                                 style="justify-content: flex-start !important">
                        {{ $t('registers.participants.updatePersonFromParticipant') }}
                    </vs-checkbox>
                </div>
                <small v-if="!isNew" id="updatePersonFromParticipantHelpBlock" class="form-text text-muted">
                    {{ $t('registers.participants.updatePersonFromParticipantDescription') }}
                </small>

                <div class="text-right mt-3">
                    <div class="btn-group" role="group" aria-label="Person edit buttons">
                        <button type="button" class="btn btn-success" @click.stop="onSave" :disabled="saving">
                            <i v-if="saving" class="fas fa-spinner fa-spin mr-2"></i>
                            <i v-else class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}
                        </button>
                        <button type="button" class="btn btn-danger" @click.stop="onCancel" :disabled="saving">
                            <i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-footer text-muted" v-if="!isNew">
                <span class="m-1">
                    <span v-if="model.creatorUsername">{{ $t('createdBy') }} <strong>{{ model.creatorUsername }}</strong></span>
                    <span v-if="model.createdAtUtc">{{ ' - ' + this.$moment(model.createdAtUtc).format('DD.MM.YYYY HH:mm:ss') }}</span>
                </span>
                <span class="m-1">
                    <span v-if="model.updaterUsername">{{ ' / ' + $t('lastUpdatedBy') }} <strong>{{ model.updaterUsername }}</strong></span>
                    <span v-if="model.updatedAtUtc">{{ ' - ' + this.$moment(model.updatedAtUtc).format('DD.MM.YYYY HH:mm:ss') }}</span>
                </span>
            </div>
        </div>
    </form>
</template>

<script>
    import { Participant } from '@/models/models';
    import PersonIdentificationComponent from '@/components/person/PersonIdentification';
    import Dropdown from '@/components/dropdown/NomenclatureDropdown';
    import CityDropdownSearch from "@/components/dropdown/CityDropdownSearch";
    import { NomenclatureParentBySort } from '@/models/enums';
    import tempRankingService from '@/services/tempRanking.service';
    import DateOnlyPicker from '@/components/datepicker/DateOnlyPicker';
    import InstitutionSelector from '@/components/common/InstitutionSelector';
    import PersonSelectorCard from '@/components/person/PersonSelectorCard'
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: Participant,
                required: false
            },
            create: {
                type: Boolean,
                default: false
            },
            validateUniqueIdNumber: {
                type: Boolean,
                default: false
            },
            validateEgn: {
                type: Boolean,
                default: false
            },
        },
        components: {
            Dropdown,
            'person-identification': PersonIdentificationComponent,
            DateOnlyPicker,
            InstitutionSelector,
            PersonSelectorCard,
            CityDropdownSearch
        },
        data() {
            return {
                model: this.value,
                files: [],
                genderTypeSort: NomenclatureParentBySort.GenderType,
                positionStatisticSort: NomenclatureParentBySort.PositionStatistic,
                positionSort: NomenclatureParentBySort.Position,
                salutationSort: NomenclatureParentBySort.Salutation,
                titleDegreeSort: NomenclatureParentBySort.TitleDegree,
                educationDegreeSort: NomenclatureParentBySort.EducationDegree,
                personSearching: false,
                saving: false
            }
        },
        methods: {
            odata4ParameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    const newOptions = kendo.data.transports["odata-v4"].parameterMap(options, operation);

                    return newOptions;
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            removeFile(file, index) {
                this.model.attachedFiles.splice(index, 1)
                this.model.deletedAttachedFilesId.push(file.id);
            },
            onCancel(e) {
                this.$emit("cancel", e);
            },
            onSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        kendo.confirm(`${this.create ? this.$t('registers.events.evaluation.tempRanking.confirmation.create') : this.$t('registers.events.evaluation.tempRanking.confirmation.update')} '${this.fullName}'?`)
                            .then(function () {
                                this.doSave();
                            }.bind(this));
                    }
                });
            },
            doSave() {
                if (Array.isArray(this.files) && this.files.length > 0) {
                    let tempFileIds = []
                    this.files.forEach(file => {
                        tempFileIds.push(file.tempId);
                    });

                    this.model.tempFileIds = tempFileIds;
                }

                if (this.create && this.isNew) {
                    // Create
                    this.createTempRankingCandidate();
                } else {
                    // Update
                    this.updateTempRankingCandidate();
                }
            },
            createTempRankingCandidate() {
                this.saving = true;

                tempRankingService
                    .createTempRankingCandidate(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('registers.events.evaluation.tempRanking.editor.create'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.saving = false });
            },
            updateTempRankingCandidate() {
                this.saving = true;

                tempRankingService
                    .updateTempRankingCandidate(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('registers.events.evaluation.tempRanking.editor.update'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => { this.saving = false });
            },
            fileRemoved(fileToRemove) {

            },
            clearFiles() {
                this.files = [];
                let fu = this.$refs.fileUpload;
                if (fu) {
                    fu.clearFiles();
                }
            }
        },
        computed: {
            ...mapGetters(['authToken', 'isEnVersion', 'tempRakingCandidateRequiredFields']),
            token: function () {
                return this.authToken;
            },
            fullName() {
                let name = this.model.person.firstName;
                if (this.model.person.middleName) {
                    name += ` ${this.model.person.middleName}`
                }

                if (this.model.person.lastName) {
                    name += ` ${this.model.person.lastName}`
                }

                return name;
            },
            isNew() {
                let id = Number(this.model.id);
                return isNaN(id) || id <= 0;
            }
        },
        mounted() {},
        watch: {
            value: function (val) {
                if (val) {
                    this.clearFiles();
                    this.model = new Participant(this.value);
                    this.$refs.personSelector.reset();
                }
            },
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
